/* RESPONSIBLE TEAM: team-knowledge-foundations */
import type AppService from 'embercom/services/app-service';
import Service, { inject as service } from '@ember/service';
import type ModalService from 'embercom/services/modal-service';
import type ContentImportService from 'embercom/services/content-import-service';
import type GuideLibraryService from 'embercom/services/guide-library-service';
import type KnowledgeHubService from 'embercom/services/knowledge-hub-service';
import type IntlService from 'embercom/services/intl';
import type UnifiedContentStateService from 'embercom/services/unified-content-state';

export default class AddWebsiteModalService extends Service {
  @service declare modalService: ModalService;
  @service declare appService: AppService;
  @service declare contentImportService: ContentImportService;
  @service declare guideLibraryService: GuideLibraryService;
  @service declare knowledgeHubService: KnowledgeHubService;
  @service declare intl: IntlService;
  @service declare notificationsService: any;
  @service declare unifiedContentState: UnifiedContentStateService;

  async postPorcessSubmission(): Promise<void> {
    this.notificationsService.notifyConfirmation(
      this.intl.t('knowledge-hub.sync-modal.source.sync-started'),
    );
    await this.contentImportService.fetchContentImportSources();
    await this.knowledgeHubService.fetchKnowledgeUsageSummary();
    this.contentImportService.subscribeToContentImportRunStatusUpdates();
    if (this.guideLibraryService.canUseGuideLibraryService) {
      this.guideLibraryService.subscribeToContentImportUpdates();
    }
    if (this.appService.app.canUseUnifiedContentUI) {
      this.unifiedContentState.refreshContent();
    }
  }

  openAddWebsiteSheet() {
    this.modalService.openModal('react/knowledge-hub/add-content/add-website/add-website-sheet', {
      open: true,
      appId: this.appService.app.id,
      adminId: this.appService.app.currentAdmin.id.toString(),
      onClose: () => this.modalService.closeModal(),
      onSubmit: async () => {
        this.modalService.closeModal();
        await this.postPorcessSubmission();
      },
    });
  }
}

declare module '@ember/service' {
  interface Registry {
    'add-website-modal-service': AddWebsiteModalService;
  }
}
